/// <reference path="../../app.typings.d.ts" />
'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var app;
(function (app) {
    var Modals;
    (function (Modals) {
        var MultipointReportConfigModalController = /** @class */ (function (_super) {
            __extends(MultipointReportConfigModalController, _super);
            function MultipointReportConfigModalController($filter, $q, $routeParams, $scope, $uibModalInstance, applicationService, locationService, metaService, ssoService, modalOptions) {
                var _this = _super.call(this, $uibModalInstance) || this;
                _this.$filter = $filter;
                _this.$q = $q;
                _this.$routeParams = $routeParams;
                _this.$scope = $scope;
                _this.$uibModalInstance = $uibModalInstance;
                _this.applicationService = applicationService;
                _this.locationService = locationService;
                _this.metaService = metaService;
                _this.ssoService = ssoService;
                _this.modalOptions = modalOptions;
                _this.applicationService.getActiveReport().then(function (activeReport) {
                    _this.$scope.activeReport = activeReport;
                    if (ap.Utilities.isNullOrUndefined(_this.$scope.activeReport)) {
                        _this.$scope.activeReport = _this.modalOptions.activeReport;
                    }
                    _this.metaService.checkMetaValues(_this.$scope.activeReport).then(function (newActiveReport) {
                        _this.$scope.activeReport = angular.copy(newActiveReport);
                        _this.initSetup();
                    });
                });
                return _this;
            }
            MultipointReportConfigModalController.prototype.initResult = function (action) {
                this.result = this.result || { action: action };
                this.result.action = action;
                return this.result;
            };
            MultipointReportConfigModalController.prototype.initSetup = function () {
                this.$scope.alphaId = this.$routeParams.organizationCacheKey.toLowerCase();
                this.dualDateMeta = this.$scope.activeReport.parameters.find(function (x) { return x.reportDataTypeId === MetaParameters.DateRangeStyleStartEnd; });
                if (!ap.Utilities.isNullOrUndefined(this.dualDateMeta)) {
                    this.$scope.dateOptions = {
                        dateDualStartObject: this.dualDateMeta.options[1],
                        dateDualEndObject: this.dualDateMeta.options[0]
                    };
                }
                // We need to pre-fill date data to prevent errors in the datepicker
                var userDate = this.$scope.activeReport.parameters.find(function (x) { return x.type === 'date' && x.value === ap.Constants.metaValues.date.custom.value; }), startDate = new Date(), endDate = new Date();
                startDate.setMonth(startDate.getMonth() - 1);
                if (!ap.Utilities.isNullOrUndefined(userDate) &&
                    !ap.Utilities.isNullOrUndefined(userDate.startDate) &&
                    !ap.Utilities.isNullOrUndefined(userDate.endDate)) {
                    startDate = userDate.startDate;
                    endDate = userDate.endDate;
                }
                this.$scope.datePicker = {
                    date: {
                        startDate: startDate,
                        endDate: endDate
                    }
                };
                this.$scope.valid = true;
            };
            MultipointReportConfigModalController.prototype.populateSubOrgs = function () {
                var _this = this;
                // Wrap active report in the format the service needs
                var reportContainer = {
                    enterpriseReports: [this.$scope.activeReport]
                };
                this.metaService.populateSubOrgs(reportContainer).then(function (updatedReport) {
                    _this.$scope.activeReport = updatedReport.enterpriseReports[0];
                });
            };
            MultipointReportConfigModalController.prototype.updateEverything = function (meta, option) {
                var setLabel = function (meta) {
                    var selectedOption = meta.options.find(function (x) { return x.value === meta.value; });
                    return !ap.Utilities.isNullOrUndefined(selectedOption) ? selectedOption.label : '';
                };
                // Handling based on input type
                switch (meta.type) {
                    case 'date':
                        if (meta.value === ap.Constants.metaValues.date.custom.value) {
                            var endDisplay = this.$filter('date')(this.$scope.datePicker.date.endDate, 'mediumDate'), startDisplay = this.$filter('date')(this.$scope.datePicker.date.startDate, 'mediumDate');
                            meta.startDate = this.$filter('date')(this.$scope.datePicker.date.startDate, 'yyyy-MM-dd');
                            meta.endDate = this.$filter('date')(this.$scope.datePicker.date.endDate, 'yyyy-MM-dd');
                            meta.displayLabel = startDisplay + " to " + endDisplay;
                        }
                        else {
                            meta.displayLabel = setLabel(meta);
                        }
                        break;
                    case 'dateStartEndMonth':
                        meta.displayLabel = this.$scope.dateOptions.dateDualStartObject.label + " to " + this.$scope.dateOptions.dateDualEndObject.label;
                        meta.value = [
                            this.$scope.dateOptions.dateDualStartObject.value,
                            this.$scope.dateOptions.dateDualEndObject.value
                        ];
                        var startDateMeta = this.$scope.activeReport.parameters.find(function (meta) { return meta.reportDataTypeId === MetaParameters.DateRangeStart; }), endDateMeta = this.$scope.activeReport.parameters.find(function (meta) { return meta.reportDataTypeId === MetaParameters.DateRangeEnd; });
                        (startDateMeta.value = this.$scope.dateOptions.dateDualStartObject.value),
                            (endDateMeta.value = this.$scope.dateOptions.dateDualEndObject.value);
                        break;
                    case 'multiCheckbox':
                        option.isSelected = !option.isSelected;
                        this.metaService.checkMultiCheckboxVals(meta, option);
                        // Update value to what's selected
                        meta.value = [];
                        meta.displayLabel = [];
                        angular.forEach(meta.options, function (option) {
                            if (option.isSelected) {
                                meta.value.push(option.value);
                                meta.displayLabel.push(option.label);
                            }
                        });
                        break;
                    default:
                        meta.value = !ap.Utilities.isNullOrUndefined(option) ? option.value : meta.value;
                        meta.displayLabel = setLabel(meta);
                        break;
                }
                // Special handling for unique params
                switch (meta.reportDataTypeId) {
                    case MetaParameters.AlphaOrg:
                        this.metaService.hierarchyNodeCacheKey = meta.value;
                        this.metaService.selectedOrgHierarchy = meta.value;
                        this.$scope.alphaId = meta.orgCacheKey;
                        this.populateSubOrgs();
                        break;
                    default:
                        break;
                }
            };
            MultipointReportConfigModalController.prototype.viewReport = function () {
                var _this = this;
                this.metaService.updateMetaValues(this.$scope.activeReport.parameters);
                // Send back to applicationService to update report values and labels
                this.applicationService
                    .setActiveReport(this.$scope.activeReport)
                    .then(function (updatedActiveReport) {
                    _this.$scope.activeReport = updatedActiveReport;
                    // If the user has updated an alpha org while editing, let's update the path
                    if (_this.$scope.activeReport.isGroupLevel &&
                        _this.$routeParams.organizationCacheKey !== _this.$scope.alphaId &&
                        !ap.Utilities.isNullOrUndefined(_this.$scope.alphaId)) {
                        _this.$uibModalInstance.close(_this.initResult(ModalActionResult.Saved));
                        _this.locationService.redirect(ap.Constants.routes.reportDisplay, _this.$scope.activeReport.ssrsName.toLowerCase(), _this.$scope.alphaId);
                    }
                    else {
                        _this.$uibModalInstance.close(_this.initResult(ModalActionResult.Saved));
                    }
                });
            };
            MultipointReportConfigModalController.$inject = [
                '$filter',
                '$q',
                '$routeParams',
                '$scope',
                '$uibModalInstance',
                'applicationService',
                'locationService',
                'metaService',
                'ssoService',
                'modalOptions'
            ];
            return MultipointReportConfigModalController;
        }(Modals.BaseModalController));
        Modals.MultipointReportConfigModalController = MultipointReportConfigModalController;
        angular
            .module('app.Modals')
            .controller('MultipointReportConfigModalController', MultipointReportConfigModalController);
    })(Modals = app.Modals || (app.Modals = {}));
})(app || (app = {}));
